/* eslint-disable */
/**
 * Desactivo slint por que no me toma el requiere , el import tampoco sirve cuando se trata de mp3, asi que no me queda otra
 */

import { useCallback, useMemo, useState } from "react";
const Music = require("./../assets/Music.mp3");

export const usePlayMusic = () => {
  const [music, setMusic] = useState<HTMLAudioElement | null>(null);

  const generateMusic = useCallback(() => {
    const currentMusic = new Audio(Music.default);
    currentMusic.volume = 0.01;
    currentMusic.loop = true;
    currentMusic.load();
    currentMusic.play();
    setMusic(currentMusic);
    return currentMusic;
  }, []);

  return useMemo(() => ({ generateMusic, music }), [music]);
};
